import { z } from 'zod'

export const LEGAL_SLUGS = ['mentions-legales', 'cgu'] as const
export type LegalSlug = (typeof LEGAL_SLUGS)[number]

export const legalSlugSchema = z.enum(LEGAL_SLUGS)

export const legalPageSchema = z.object({
  title: z.string().min(1, 'Le titre est obligatoire'),
  bodyMarkdown: z.string().min(1, 'Le contenu est obligatoire'),
})

export type LegalPage = z.infer<typeof legalPageSchema>
